import { AssessmentCriteria, AssessmentCriteriaInputValues } from '../constants/Constants';
export const mapAssessmentNameToAchieved = (name) => {
    if (name === AssessmentCriteria.ACHIEVED) return AssessmentCriteriaInputValues.YES;
    if (name === AssessmentCriteria.NOT_ACHIEVED) return AssessmentCriteriaInputValues.NO;
    if (name === AssessmentCriteria.NOT_ATTEMPTED) return AssessmentCriteriaInputValues.NOT_ATTEMPTED;
    return null;

  };

  export const mapAchievedToAssessmentName = (val) => {
    if (val === AssessmentCriteriaInputValues.YES) return AssessmentCriteria.ACHIEVED;
    if (val === AssessmentCriteriaInputValues.NO) return AssessmentCriteria.NOT_ACHIEVED;
    if (val === AssessmentCriteriaInputValues.NOT_ATTEMPTED) return AssessmentCriteria.NOT_ATTEMPTED;
    return null;
  };